// languageMapping.js
export const languageMapping = {
  gujarati: ['ગુજરાત', 'દિલ્હી'], // Add all Gujarati states here
  hindi: ['राजस्थान', 'उत्तर प्रदेश'], // Add all Hindi states here
  english: ['MAHARASHTRA', 'KARNATAKA', 'TAMIL NADU'], // Add all English states here
};
